import { Turbo } from '@hotwired/turbo-rails';

Turbo.StreamActions.scroll_to = function () {
  const id = this.getAttribute('id');
  const target = document.getElementById(id).parentElement;
  target.scrollIntoView({ behavior: "smooth" });
};
